import { useColorModeValue } from "@chakra-ui/color-mode";
import { Flex, Text } from "@chakra-ui/layout";
import React from "react";

import RewardList from "../../Rewards/components/rewardList";
import NowGame from "./nowGame";

const RewardDetail = () => {
  const textColor = useColorModeValue("dark.100", "light.100");
  return (
    <Flex direction={`column`} gap="10px">
      <NowGame />
      <Text color={textColor} as="p">
        My Rewards
      </Text>
      <RewardList />
    </Flex>
  );
};

export default RewardDetail;
